<template>
  <section
    data-aos="fade"
    id="features"
    class="bg-[#f9f5f0] pt-24 relative sm:pt-32 lg:py-32"
  >
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -top-4 w-full"
      height="32"
      width="375"
    />
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -bottom-4 -scale-100 w-full"
      height="32"
      width="375"
    />
    <div data-aos="fade-up" class="mx-auto max-w-7xl px-6 lg:px-8">
      <div
        class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-5"
      >
        <div class="col-span-2 relative pb-4">
          <h2 class="text-base/7 font-semibold text-purple-600 relative">
            <img
              :src="Arrow"
              alt="Arrow drawing squiggle"
              class="absolute h-16 w-auto right-0 bottom-0 -scale-x-100 sm:right-auto sm:-left-32 sm:scale-x-100"
              height="64"
              width="80"
            />
            Everything you need
          </h2>
          <p
            class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl"
          >
            Be part of the
            <span class="relative inline-block">
              <img
                :src="PurpleHeart"
                alt="Purple heart drawing"
                class="hidden sm:block absolute -top-4 w-4 left-2 -scale-x-100"
                height="16"
                width="16"
              />
              <img
                :src="GreenHeart"
                alt="Green heart drawing"
                class="hidden sm:block absolute -top-8 w-8 right-0"
                height="32"
                width="32"
              />
              journey,
            </span>
            see your child’s school day like never before.
          </p>
          <p class="mt-6 text-base/7 text-gray-600">
            We believe that the key to pupil success is a strong home-school
            partnership.
          </p>
        </div>
        <dl
          class="col-span-3 grid grid-cols-1 gap-x-8 gap-y-10 text-base/7 text-gray-600 sm:grid-cols-2 lg:gap-y-12"
        >
          <div v-for="item in list" :key="item.id" class="relative pl-9">
            <dt class="font-semibold text-gray-900">
              <i class="text-purple-600 me-2" :class="item.icon"></i>
              {{ item.title }}
            </dt>
            <dd class="mt-2">
              {{ item.body }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <img
      data-aos="fade-left"
      :src="Mockup"
      alt="Mobile prototype mockup"
      class="relative h-96 mt-12 -bottom-4 ms-auto w-auto lg:mt-0 lg:absolute lg:left-1/5"
      height="384"
      width="375"
      loading="lazy"
    />
  </section>
</template>
<script setup lang="ts">
import BeigeBorder from "/graphics/expert-top.svg";
import GreenHeart from "/graphics/green/heart.svg";
import PurpleHeart from "/graphics/purple/heart.svg";
import Arrow from "/graphics/purple/arrow-2.svg";
import Mockup from "/mockups/1.webp";

const list = [
  {
    id: 1,
    title: "Real updates from the classroom",
    body: "Get badges, points, observations and praise from your child’s teacher.",
    icon: "fas fa-comment-dots",
  },
  {
    id: 2,
    title: "School news, your way",
    body: "Stay up to date with regular news from school - never miss an update again.",
    icon: "fas fa-newspaper",
  },
  {
    id: 3,
    title: "View and book upcoming events",
    body: "School calendar, booked events and parent evenings all in one place.",
    icon: "fas fa-calendar-alt",
  },
  {
    id: 4,
    title: "Celebrate achievements",
    body: "Get notified when your child earns rewards or gets recognised at school.",
    icon: "fas fa-award",
  },
  {
    id: 5,
    title: "Track attendance easily",
    body: "No more wondering - check your child’s attendance record anytime.",
    icon: "fas fa-clipboard-list",
  },
  {
    id: 6,
    title: "App messages directly to you",
    body: "Receive app messages from school all in one in place - no more old-fashioned text messages or lost emails.",
    icon: "fas fa-chalkboard-teacher",
  },
  {
    id: 7,
    title: "React, comment, engage",
    body: "Staying involved is just a tap away – whether it’s a like, a comment, or a quick emoji to show your support.",
    icon: "fas fa-heart",
  },
];
</script>
